<!-- 关于我们页面 -->
<template>
  <div class="about-page">
    <Navbar />

    <!-- 页头 -->
    <section class="about-hero">
      <div class="about-hero-overlay"></div>
      <div class="about-hero-particles">
        <span v-for="n in 8" :key="n" class="particle" :style="{ '--i': n }"></span>
      </div>
      <div class="container">
        <div class="about-hero-content">
          <span class="section-tag">ABOUT US</span>
          <h1 class="about-hero-title">关于我们</h1>
          <p class="about-hero-desc">高端汽车无痕修复 · 原厂漆守护者 · 京城车主信赖之选</p>
          <div class="hero-divider">
            <span class="line"></span>
            <span class="diamond"></span>
            <span class="line"></span>
          </div>
        </div>
      </div>
    </section>

    <!-- 公司简介 -->
    <section class="company-intro">
      <div class="container">
        <div class="intro-grid">
          <div class="intro-image">
            <img :src="require('@/components/images/宣传图.png')" alt="科曼驰团队" class="intro-img" />
            <div class="intro-badge">
            </div>
          </div>
          <div class="intro-content">
            <span class="section-tag">COMPANY PROFILE</span>
            <h2 class="section-title">北京科曼驰汽车服务有限公司</h2>
            <p class="intro-text">
              科曼驰专注汽车无痕凹陷修复（PDR）、挡风玻璃微创修复以及局部点漆服务。我们采用德国先进技术工艺，全程保留原厂漆面，让爱车价值最大化。
            </p>
            <p class="intro-text">
              公司拥有一支经验丰富、技术精湛的专业修复团队，多年宾利、保时捷、奔驰、宝马等高端车修复案例，是京城众多车主信赖的汽车美容修复专家。
            </p>
            <div class="intro-tags">
              <div class="intro-tag">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#d4af37" stroke-width="2">
                  <polyline points="20 6 9 17 4 12"/>
                </svg>
                <span>原厂漆保留</span>
              </div>
              <div class="intro-tag">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#d4af37" stroke-width="2">
                  <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
                </svg>
                <span>一小时快修</span>
              </div>
              <div class="intro-tag">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#d4af37" stroke-width="2">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                </svg>
                <span>两年质保</span>
              </div>
              <div class="intro-tag">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#d4af37" stroke-width="2">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
                </svg>
                <span>上门服务</span>
              </div>
            </div>
            <router-link to="/product" class="btn-gold">查看服务详情 →</router-link>
          </div>
        </div>
      </div>
    </section>

    <!-- 发展历程 -->
    <section class="timeline-section">
      <div class="container">
        <div class="section-header">
          <span class="section-tag">HISTORY</span>
          <h2 class="section-title">发展历程</h2>
          <p class="section-subtitle">专注 · 成长 · 突破</p>
        </div>
        <div class="timeline">
          <div
            v-for="(item, index) in timelineData"
            :key="index"
            class="timeline-item"
            :class="{ 'is-left': index % 2 === 0, 'is-right': index % 2 !== 0 }"
          >
            <div class="timeline-content">
              <span class="timeline-year">{{ item.year }}</span>
              <h4 class="timeline-title">{{ item.title }}</h4>
              <p class="timeline-desc">{{ item.desc }}</p>
            </div>
            <div class="timeline-dot"></div>
          </div>
        </div>
      </div>
    </section>

    <!-- 核心优势 -->
    <section class="advantages-section">
      <div class="container">
        <div class="section-header">
          <span class="section-tag">WHY CHOOSE US</span>
          <h2 class="section-title">核心优势</h2>
          <p class="section-subtitle">专业团队 · 德国工艺 · 品质保障</p>
        </div>
        <div class="advantages-grid">
          <div
            v-for="(item, index) in advantagesData"
            :key="index"
            class="advantage-card"
            :style="{ animationDelay: index * 0.1 + 's' }"
          >
            <div class="advantage-icon-wrap">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#d4af37" stroke-width="1.5">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
              </svg>
            </div>
            <h4>{{ item.title }}</h4>
            <p>{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 团队展示 -->
    <section class="team-section">
      <div class="container">
        <div class="section-header">
          <span class="section-tag">OUR TEAM</span>
          <h2 class="section-title">专业团队</h2>
          <p class="section-subtitle">经验丰富的修复技师 · 严谨细致的服务态度</p>
        </div>
        <div class="team-grid">
          <div
            v-for="(member, index) in teamData"
            :key="index"
            class="team-card"
            @click="openMemberDetail(index)"
          >
            <div class="team-avatar">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#d4af37" stroke-width="1.5"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
            </div>
            <h4>{{ member.name }}</h4>
            <span class="team-role">{{ member.role }}</span>
            <p class="team-bio">{{ member.bio }}</p>
            <div class="team-card-footer">
              <span class="team-exp">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#d4af37" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                {{ member.experience }}年经验
              </span>
              <span class="team-view">
                了解详情
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 成员详情弹窗 -->
    <div class="member-overlay" :class="{ open: memberDetailOpen }" @click.self="closeMemberDetail">
      <button class="member-close" @click="closeMemberDetail">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>
      <button class="member-prev" @click.stop="prevMember" :disabled="memberDetailIndex === 0">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"/></svg>
      </button>
      <div class="member-container" @click.stop>
        <div class="member-photo-wrap">
          <div class="member-avatar-large">
            <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#d4af37" stroke-width="1.2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
          </div>
          <div class="member-photo-info">
            <span class="section-tag">{{ currentMember?.title || 'TEAM MEMBER' }}</span>
            <h2 class="member-photo-name">{{ currentMember?.name }}</h2>
            <p class="member-photo-role">{{ currentMember?.role }}</p>
            <div class="member-photo-divider">
              <span class="line"></span>
              <span class="diamond"></span>
              <span class="line"></span>
            </div>
          </div>
        </div>
        <div class="member-details">
          <div class="member-stats-row">
            <div class="member-stat">
              <span class="stat-num">{{ currentMember?.experience }}</span>
              <span class="stat-label">年从业经验</span>
            </div>
            <div class="member-stat-divider"></div>
            <div class="member-stat">
              <span class="stat-num">{{ currentMember?.cases || '2000' }}</span>
              <span class="stat-label">服务案例</span>
            </div>
            <div class="member-stat-divider"></div>
            <div class="member-stat">
              <span class="stat-num">{{ currentMember?.certCount || '5' }}</span>
              <span class="stat-label">专业认证</span>
            </div>
          </div>
          <div class="member-section">
            <h5 class="member-section-title">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#d4af37" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
              个人简介
            </h5>
            <p class="member-bio-full">{{ currentMember?.bioFull }}</p>
          </div>
          <div class="member-section">
            <h5 class="member-section-title">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#d4af37" stroke-width="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
              擅长领域
            </h5>
            <div class="member-tags">
              <span v-for="(tag, ti) in currentMember?.tags" :key="ti" class="member-tag">{{ tag }}</span>
            </div>
          </div>
          <div class="member-section" v-if="currentMember?.certifications?.length">
            <h5 class="member-section-title">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#d4af37" stroke-width="2"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>
              资质荣誉
            </h5>
            <ul class="member-certs">
              <li v-for="(cert, ci) in currentMember.certifications" :key="ci">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#d4af37" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg>
                {{ cert }}
              </li>
            </ul>
          </div>
          <div class="member-section" v-if="currentMember?.quote">
            <blockquote class="member-quote">{{ currentMember.quote }}</blockquote>
          </div>
          <div class="member-actions">
            <button class="btn-back" @click="closeMemberDetail">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>
              返回列表
            </button>
            <button class="btn-next" @click="nextMember" :disabled="memberDetailIndex === teamData.length - 1">
              下一位
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
            </button>
          </div>
        </div>
      </div>
      <button class="member-next" @click.stop="nextMember" :disabled="memberDetailIndex === teamData.length - 1">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>
      </button>
    </div>

    <!-- ===== 资质荣誉 ===== -->
    <section class="cert-section" v-if="certList.length > 0">
      <div class="container">
        <div class="section-header">
          <span class="section-tag">CERTIFICATES</span>
          <h2 class="section-title">资质荣誉</h2>
          <p class="section-subtitle">专业认证 · 技术实力 · 品牌保障</p>
        </div>
        <div class="cert-carousel" @mouseenter="stopCertAutoplay" @mouseleave="startCertAutoplay">
          <!-- 左箭头 -->
          <button class="cert-nav cert-nav-prev" @click="prevCertSlide" v-if="certList.length > 4">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="15 18 9 12 15 6"/>
            </svg>
          </button>
          <!-- 右箭头 -->
          <button class="cert-nav cert-nav-next" @click="nextCertSlide" v-if="certList.length > 4">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="9 18 15 12 9 6"/>
            </svg>
          </button>
          <div class="cert-track" :style="{ transform: `translateX(-${certOffset * 264}px)` }">
            <div
              v-for="(cert, index) in certList"
              :key="cert.id"
              class="cert-item"
              @click="openLightbox(index)"
            >
              <div class="cert-img-wrap">
                <img :src="cert.img ? '' + cert.img : ''" :alt="cert.title" class="cert-img" v-if="cert.img" />
                <div class="cert-zoom">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="11" cy="11" r="8"/>
                    <line x1="21" y1="21" x2="16.65" y2="16.65"/>
                    <line x1="11" y1="8" x2="11" y2="14"/>
                    <line x1="8" y1="11" x2="14" y2="11"/>
                  </svg>
                </div>
              </div>
              <p class="cert-title">{{ cert.title }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 大图预览 -->
    <div class="lightbox" :class="{ open: lightboxOpen }" @click="closeLightbox">
      <button class="lightbox-close" @click.stop="closeLightbox">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>
      <button class="lightbox-prev" @click.stop="prevCert">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"/></svg>
      </button>
      <div class="lightbox-content" @click.stop v-if="certList[lightboxIndex]?.img">
        <img :src="'' + certList[lightboxIndex]?.img" :alt="certList[lightboxIndex]?.title" class="lightbox-img" />
      </div>
      <button class="lightbox-next" @click.stop="nextCert">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>
      </button>
      <p class="lightbox-caption">{{ certList[lightboxIndex]?.title }}</p>
    </div>

    <!-- CTA -->
    <section class="about-cta">
      <div class="container">
        <div class="cta-content">
          <span class="section-tag">GET IN TOUCH</span>
          <h2>选择科曼驰，守护您的爱车</h2>
          <p>科曼驰团队为您提供免费凹陷评估及修复方案</p>
          <div class="cta-actions">
            <a href="tel:159-3133-4385" class="btn-gold">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
              立即预约
            </a>
            <router-link to="/contact" class="btn-outline-dark">联系我们</router-link>
          </div>
        </div>
      </div>
    </section>

    <el-backtop :visibility-height="200" />
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import Navbar from '@/components/Navbar.vue'
import axios from 'axios'
const timelineData = ref([
  { year: '2025.10', title: '公司成立', desc: '北京科曼驰汽车服务有限公司正式注册成立，专注汽车无痕修复领域。' },
  { year: '2026.01', title: '技术引进', desc: '引入德国PDR无痕修复技术，建立标准化施工流程，团队完成专业认证培训。' },
  { year: '2026.05', title: '业务拓展', desc: '新增挡风玻璃微创修复与局部点漆服务，服务品类覆盖更广泛的车主需求。' },
  { year: '2026.06', title: '上门服务', desc: '启动北京全域移动服务车，为客户提供便捷上门修复服务，响应时间大幅缩短。' },
  { year: '2026.09', title: '品质升级', desc: '修复案例突破3000台，满意度达99%，荣获多项软件著作权及专利认证。' },
])

// 核心优势
const advantagesData = ref([
  { title: '原厂漆保留', desc: '拒绝钣金喷漆，全程无损修复，保留原始漆面质感与厚度，车辆保值最大化。' },
  { title: '一小时快修', desc: '多数凹陷1小时内完成修复，即修即走，无需长时间等待，高效便捷。' },
  { title: '高端车专修', desc: '宾利/保时捷/奔驰/宝马等数千台案例，技术精湛，经验丰富，值得信赖。' },
  { title: '两年质保', desc: '所有修复项目提供两年质保服务，质保期内免费返修，让您无忧用车。' },
  { title: '上门服服务', desc: '北京全域移动服务车，快速响应，就近上门，节省您的宝贵时间。' },
  { title: '专业认证', desc: '技师均通过德国PDR技术认证，持有专业资格证书，技术实力有保障。' },
])

// 团队数据
const teamData = ref([
  {
    name: '陈帅',
    role: '创始人 / 技术总监',
    title: 'FOUNDER',
    bio: '8年汽车无痕修复经验，德国PDR技术认证技师，擅长高端车型精密修复。',
    experience: 8,
    cases: '3000+',
    certCount: 4,
    bioFull: '北京科曼驰汽车服务有限公司创始人，深耕汽车无痕凹陷修复领域8年。早年接受系统性的PDR技术培训，持有三级汽车维修工证书。擅长宾利、保时捷、奔驰、宝马等高端车型的精密修复，累计完成超过3000例成功案例。创立科曼驰以来，始终坚持以技术为核心、以服务为根本的理念，带领团队成为京城高端车修复领域的标杆企业。',
    tags: ['高端车精密修复', '冰雹坑修复', 'PDR技术', '技术培训'],
    certifications: ['三级汽车维修工证书', '中国汽车美容行业协会理事', '软件著作权持有人（10项）', '国家发明专利持有人'],
    quote: '每一辆车都值得被认真对待，原厂漆是车的灵魂，我们用技术守护它。',
  },
  {
    name: '王嘉伟',
    role: '高级修复技师',
    title: 'SENIOR TECHNICIAN',
    bio: '8年修复经验，专注于凹陷修复与玻璃修复，累计完成2000+修复案例。',
    experience: 8,
    cases: '2000+',
    certCount: 3,
    bioFull: '科曼驰核心修复技师，8年汽车凹陷修复实战经验。毕业于汽车美容与修复专业，师从德国PDR认证技师系统学习无痕修复技术。擅长车门凹陷、引擎盖凹痕、翼子板修复等常规及复杂场景，对高端车型曲面修复有独到见解。工作中注重细节，追求极致，是团队中业绩最高的技师之一。',
    tags: ['车门凹陷修复', '引擎盖修复', '高端曲面修复', '玻璃微创修复'],
    certifications: ['德国PDR认证技师', '中国汽车维修行业协会技术等级认证', '玻璃修复专项认证'],
    quote: '修复的不仅仅是凹陷，更是对每一位车主信任的回应。',
  },
  {
    name: '张磊',
    role: '玻璃修复专家',
    title: 'GLASS SPECIALIST',
    bio: '3年玻璃修复经验，精通各种裂纹、破损的微创修复技术。',
    experience: 3,
    cases: '1500+',
    certCount: 2,
    bioFull: '科曼驰玻璃修复专项技师，3年专注挡风玻璃微创修复领域。精通牛眼裂纹、星状破损、长裂缝等各类玻璃损伤的修复技术，采用进口修复树脂配合专业设备，修复后强度接近原厂玻璃标准。擅长评估修复可行性，以最低成本帮助车主避免高额换玻璃费用，赢得客户高度认可。',
    tags: ['牛眼裂纹修复', '星状破损', '长裂缝修复', '树脂注胶技术'],
    certifications: ['德国PTR玻璃修复认证', '进口树脂技术专项培训证书'],
    quote: '好的玻璃修复能让车主省下大笔费用，同时确保行车安全。',
  },
  {
    name: '赵婷',
    role: '客户服务主管',
    title: 'SERVICE MANAGER',
    bio: '负责预约调度与客户沟通，确保每位车主获得贴心服务体验。',
    experience: 4,
    cases: '—',
    certCount: 2,
    bioFull: '科曼驰客户服务主管，4年汽车服务行业经验。负责日常预约调度、客户沟通、售后跟进等全流程服务管理。建立了一套高效的服务响应机制，确保客户咨询30分钟内得到回复，紧急需求2小时内上门响应。以亲切专业的服务态度，帮助无数车主解决了车辆损伤困扰，是客户心中的"贴心管家"。',
    tags: ['预约调度', '客户服务', '售后跟进', '上门协调'],
    certifications: ['客户服务管理认证', '汽车服务行业标准培训证书'],
    quote: '让客户从咨询到提车全程无忧，是我们服务的最高标准。',
  },
])

// 资质荣誉数据
const certList = ref([])
const certOffset = ref(0)
let certTimer = null

// 从 API 加载荣誉证书
const loadCertList = async () => {
  try {
    const res = await axios.get('/webapi/cert/list')
    if (res.data.ActionType === 'OK' && res.data.data) {
      certList.value = res.data.data.map((cert, index) => ({
        id: cert._id || index,
        img: cert.img,
        title: cert.title
      }))
    }
  } catch (e) {
    certList.value = [
      { id: 1, img: '软件著作权证书.png', title: '软件著作权证书' },
      { id: 2, img: '软件著作权证书 - 副本.png', title: '软件著作权证书' },
      { id: 3, img: '软件著作权证书 - 副本 (2).png', title: '软件著作权证书' },
      { id: 4, img: '专利.png', title: '发明专利证书' },
    ]
  }
}

// 自动轮播
const startCertAutoplay = () => {
  certTimer = setInterval(() => {
    certOffset.value = (certOffset.value + 1) % certList.value.length
  }, 3000)
}

const stopCertAutoplay = () => {
  if (certTimer) {
    clearInterval(certTimer)
    certTimer = null
  }
}

// 轮播导航
const prevCertSlide = () => {
  certOffset.value = (certOffset.value - 1 + certList.value.length) % certList.value.length
  stopCertAutoplay()
  startCertAutoplay()
}

const nextCertSlide = () => {
  certOffset.value = (certOffset.value + 1) % certList.value.length
  stopCertAutoplay()
  startCertAutoplay()
}

const lightboxOpen = ref(false)
const lightboxIndex = ref(0)

const openLightbox = (index) => {
  lightboxIndex.value = index % certList.value.length
  lightboxOpen.value = true
  document.body.style.overflow = 'hidden'
}

const closeLightbox = () => {
  lightboxOpen.value = false
  document.body.style.overflow = ''
}

const prevCert = () => {
  lightboxIndex.value = (lightboxIndex.value - 1 + certList.value.length) % certList.value.length
}

const nextCert = () => {
  lightboxIndex.value = (lightboxIndex.value + 1) % certList.value.length
}

const handleKeydown = (e) => {
  if (!lightboxOpen.value) return
  if (e.key === 'ArrowLeft') prevCert()
  else if (e.key === 'ArrowRight') nextCert()
  else if (e.key === 'Escape') closeLightbox()
}

const memberDetailOpen = ref(false)
const memberDetailIndex = ref(0)

const currentMember = computed(() => teamData.value[memberDetailIndex.value] || null)

const openMemberDetail = (index) => {
  memberDetailIndex.value = index
  memberDetailOpen.value = true
  document.body.style.overflow = 'hidden'
}

const closeMemberDetail = () => {
  memberDetailOpen.value = false
  document.body.style.overflow = ''
}

const nextMember = () => {
  if (memberDetailIndex.value < teamData.value.length - 1) {
    memberDetailIndex.value++
  }
}

const prevMember = () => {
  if (memberDetailIndex.value > 0) {
    memberDetailIndex.value--
  }
}

const handleMemberKeydown = (e) => {
  if (!memberDetailOpen.value) return
  if (e.key === 'ArrowLeft') prevMember()
  else if (e.key === 'ArrowRight') nextMember()
  else if (e.key === 'Escape') closeMemberDetail()
}

onMounted(async () => {
  window.addEventListener('keydown', handleMemberKeydown)
  window.addEventListener('keydown', handleKeydown)
  await loadCertList()
  if (certList.value.length > 4) {
    startCertAutoplay()
  }
})
onUnmounted(() => {
  window.removeEventListener('keydown', handleMemberKeydown)
  window.removeEventListener('keydown', handleKeydown)
  if (certTimer) clearInterval(certTimer)
  // 页面切换时始终清理 overflow，防止其他页面滚动异常
  document.body.style.overflow = ''
})

</script>

<style scoped lang="scss">
// ===== 变量 =====
$gold: #d4af37;
$dark: #1a1a1a;
$gray: #6b7280;
$light-gray: #f8f9fa;
$border: #e5e7eb;

// ===== 全局 =====
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

.section-tag {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 4px;
  text-transform: uppercase;
  color: $gold;
  display: block;
  margin-bottom: 12px;
}

.section-title {
  font-size: 36px;
  font-weight: 800;
  color: $dark;
  margin: 8px 0 12px;
}

.section-subtitle {
  font-size: 16px;
  color: $gray;
}

.section-header {
  text-align: center;
  margin-bottom: 56px;
}

.hero-divider {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin: 28px 0;

  .line {
    width: 80px;
    height: 1px;
    background: linear-gradient(to right, transparent, $gold, transparent);
    opacity: 0.5;
  }

  .diamond {
    width: 6px;
    height: 6px;
    background: $gold;
    transform: rotate(45deg);
  }
}

.hero-stats-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 32px;
  margin-top: 24px;

  .hero-stat {
    display: flex;
    align-items: baseline;
    gap: 2px;

    .stat-num {
      font-size: 32px;
      font-weight: 800;
      color: #fff;
      line-height: 1;
    }

    .stat-suffix {
      font-size: 16px;
      font-weight: 600;
      color: $gold;
    }

    .stat-label {
      display: block;
      font-size: 12px;
      color: rgba(255,255,255,0.5);
      margin-top: 4px;
      letter-spacing: 1px;
    }
  }

  .hero-stat-divider {
    width: 1px;
    height: 36px;
    background: rgba(255,255,255,0.15);
  }
}

// ===== 页头 =====
.about-hero {
  position: relative;
  min-height: 520px;
  background: linear-gradient(135deg, $dark 0%, #2a2a2a 100%);
  display: flex;
  align-items: center;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: -20%;
    left: -5%;
    width: 700px;
    height: 700px;
    background: radial-gradient(circle, rgba(212,175,55,0.08) 0%, transparent 70%);
    border-radius: 50%;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, $gold, transparent);
    opacity: 0.3;
  }
}

.about-hero-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.2) 100%);
}

.about-hero-particles {
  position: absolute;
  inset: 0;
  pointer-events: none;

  .particle {
    position: absolute;
    width: 4px;
    height: 4px;
    background: $gold;
    border-radius: 50%;
    opacity: 0;
    box-shadow: 0 0 8px $gold;
    animation: floatParticle 4s ease-in-out infinite;
    animation-delay: calc(var(--i) * 0.4s);
  }
}

@keyframes floatParticle {
  0%, 100% { transform: translateY(0) scale(1); opacity: 0.2; }
  50% { transform: translateY(-40px) scale(1.3); opacity: 0.6; }
}

.about-hero-content {
  position: relative;
  z-index: 2;
  padding: 60px 0;
  text-align: center;

  .about-hero-title {
    font-size: 52px;
    font-weight: 800;
    color: #fff;
    letter-spacing: 2px;
    margin-bottom: 16px;
  }

  .about-hero-desc {
    font-size: 17px;
    color: rgba(255,255,255,0.6);
    letter-spacing: 1px;
  }
}

// ===== 公司简介 =====
.company-intro {
  padding: 80px 0;
  background: #fff;

  .intro-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 60px;
    align-items: center;
  }

  .intro-image {
    position: relative;

    .intro-img {
      width: 100%;
      height: 420px;
      object-fit: cover;
      border-radius: 16px;
    }

    .intro-badge {
      position: absolute;
      bottom: 24px;
      left: 24px;
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 12px 20px;
      background: rgba(0, 0, 0, 0.8);
      backdrop-filter: blur(8px);
      border-radius: 12px;

      .badge-icon {
        display: flex;
        align-items: center;
      }

      .badge-text {
        font-size: 13px;
        font-weight: 600;
        color: #fff;
      }
    }
  }

  .intro-content {
    .section-tag { margin-bottom: 12px; }

    .section-title {
      font-size: 32px;
      margin-bottom: 20px;
    }

    .intro-text {
      font-size: 15px;
      line-height: 1.8;
      color: $gray;
      margin-bottom: 16px;
    }

    .intro-tags {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 12px;
      margin: 28px 0;

      .intro-tag {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 12px 16px;
        background: $light-gray;
        border-radius: 10px;
        font-size: 14px;
        font-weight: 500;
        color: $dark;
      }
    }

    .btn-gold {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      padding: 12px 28px;
      font-size: 14px;
      font-weight: 600;
      color: $dark;
      background: $gold;
      border: none;
      border-radius: 8px;
      text-decoration: none;
      transition: all 0.3s ease;

      &:hover {
        background: #c4a030;
        transform: translateY(-2px);
        box-shadow: 0 8px 24px rgba(212,175,55,0.3);
      }
    }
  }
}

// ===== 发展历程 =====
.timeline-section {
  padding: 80px 0;
  background: $light-gray;
}

.timeline {
  position: relative;
  max-width: 900px;
  margin: 0 auto;

  &::before {
    content: '';
    position: absolute;
    left: 50%;
    top: 0;
    bottom: 0;
    width: 2px;
    background: linear-gradient(to bottom, transparent, $gold, transparent);
    transform: translateX(-50%);
  }
}

.timeline-item {
  display: flex;
  align-items: center;
  margin-bottom: 40px;
  position: relative;

  &.is-left {
    justify-content: flex-start;

    .timeline-content {
      text-align: right;
      padding-right: 60px;
      margin-right: 10px;
    }
  }

  &.is-right {
    justify-content: flex-end;

    .timeline-content {
      text-align: left;
      padding-left: 60px;
      margin-left: 10px;
    }
  }

  .timeline-content {
    width: 50%;
    background: #fff;
    padding: 24px;
    border-radius: 12px;
    box-shadow: 0 4px 16px rgba(0,0,0,0.06);
    border: 1px solid $border;
    overflow: visible;

    .timeline-year {
      font-size: 13px;
      font-weight: 700;
      color: $gold;
      letter-spacing: 2px;
    }

    .timeline-title {
      font-size: 17px;
      font-weight: 700;
      color: $dark;
      margin: 6px 0 8px;
    }

    .timeline-desc {
      font-size: 14px;
      color: $gray;
      line-height: 1.7;
    }
  }

  .timeline-dot {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    left: 50%;
    transform: translateX(-50%);
    width: 16px;
    height: 16px;
    background: $gold;
    border: 3px solid #fff;
    border-radius: 50%;
    box-shadow: 0 0 0 3px rgba(212,175,55,0.2);
    z-index: 2;
  }

  &.is-left .timeline-dot {
    left: 100%;
    transform: translateX(0);
  }

  &.is-right .timeline-dot {
    left: 0;
    transform: translateX(-100%);
  }
}

// ===== 核心优势 =====
.advantages-section {
  padding: 80px 0;
  background: #fff;
}

.advantages-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.advantage-card {
  padding: 32px 24px;
  background: $light-gray;
  border-radius: 12px;
  text-align: center;
  transition: all 0.4s ease;
  border: 1px solid transparent;
  opacity: 0;
  transform: translateY(20px);
  animation: cardSlideUp 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards;

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 12px 32px rgba(0,0,0,0.08);
    border-color: rgba(212,175,55,0.2);

    .advantage-icon-wrap {
      background: rgba(212,175,55,0.12);
    }
  }

  .advantage-icon-wrap {
    width: 64px;
    height: 64px;
    margin: 0 auto 16px;
    background: rgba(212,175,55,0.08);
    border: 1px solid rgba(212,175,55,0.15);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
  }

  h4 {
    font-size: 17px;
    font-weight: 700;
    color: $dark;
    margin-bottom: 8px;
  }

  p {
    font-size: 14px;
    color: $gray;
    line-height: 1.7;
  }
}

@keyframes cardSlideUp {
  to { opacity: 1; transform: translateY(0); }
}

// ===== 团队 =====
.team-section {
  padding: 80px 0;
  background: $light-gray;
}

.team-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

.team-card {
  background: #fff;
  border-radius: 16px;
  padding: 32px 20px;
  text-align: center;
  border: 1px solid $border;
  transition: all 0.4s ease;

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 16px 40px rgba(0,0,0,0.08);
    border-color: rgba(212,175,55,0.3);
  }

  .team-avatar {
    width: 72px;
    height: 72px;
    margin: 0 auto 16px;
    background: rgba(212,175,55,0.08);
    border: 2px solid rgba(212,175,55,0.2);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  h4 {
    font-size: 18px;
    font-weight: 700;
    color: $dark;
    margin-bottom: 4px;
  }

  .team-role {
    display: block;
    font-size: 13px;
    font-weight: 500;
    color: $gold;
    margin-bottom: 12px;
  }

  .team-bio {
    font-size: 13px;
    color: $gray;
    line-height: 1.7;
  }

  .team-card-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid $border;
  }
}

// ===== 成员详情弹窗 =====
.member-overlay {
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: rgba(0, 0, 0, 0.88);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.35s ease;

  &.open {
    opacity: 1;
    pointer-events: auto;
  }
}

.member-close {
  position: absolute;
  top: 24px;
  right: 24px;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 10;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: rotate(90deg);
  }
}

.member-prev,
.member-next {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 52px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 10;

  &:hover:not(:disabled) {
    background: rgba(212, 175, 55, 0.3);
    border-color: $gold;
  }

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
}

.member-prev { left: 24px; }
.member-next { right: 24px; }

.member-container {
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  gap: 0;
  max-width: 960px;
  width: 92%;
  max-height: 88vh;
  background: #fff;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 32px 80px rgba(0, 0, 0, 0.5);
  animation: memberZoomIn 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

@keyframes memberZoomIn {
  from {
    transform: scale(0.9) translateY(30px);
    opacity: 0;
  }
  to {
    transform: scale(1) translateY(0);
    opacity: 1;
  }
}

.member-photo-wrap {
  position: relative;
  background: linear-gradient(135deg, $dark 0%, #2a2a2a 100%);
  padding: 48px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: -30%;
    right: -20%;
    width: 300px;
    height: 300px;
    background: radial-gradient(circle, rgba(212, 175, 55, 0.1) 0%, transparent 70%);
    border-radius: 50%;
  }

  .member-avatar-large {
    width: 110px;
    height: 110px;
    background: rgba(212, 175, 55, 0.1);
    border: 2px solid rgba(212, 175, 55, 0.3);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 24px;
    position: relative;
    z-index: 1;
  }
}

.member-photo-info {
  position: relative;
  z-index: 1;

  .section-tag {
    margin-bottom: 12px;
    opacity: 0.8;
  }

  .member-photo-name {
    font-size: 28px;
    font-weight: 800;
    color: #fff;
    margin-bottom: 8px;
    letter-spacing: 1px;
  }

  .member-photo-role {
    font-size: 14px;
    color: $gold;
    font-weight: 500;
    letter-spacing: 1px;
    margin-bottom: 20px;
  }

  .member-photo-divider {
    display: flex;
    align-items: center;
    gap: 10px;
    opacity: 0.5;

    .line {
      flex: 1;
      height: 1px;
      background: linear-gradient(to right, transparent, $gold, transparent);
    }

    .diamond {
      width: 5px;
      height: 5px;
      background: $gold;
      transform: rotate(45deg);
    }
  }
}

.member-details {
  padding: 36px 32px;
  display: flex;
  flex-direction: column;
  gap: 0;
  overflow-y: auto;
}

.member-stats-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0;
  padding: 20px;
  background: $light-gray;
  border-radius: 12px;
  margin-bottom: 24px;

  .member-stat {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;

    .stat-num {
      font-size: 28px;
      font-weight: 800;
      color: $gold;
      line-height: 1;
    }

    .stat-label {
      font-size: 12px;
      color: $gray;
      margin-top: 6px;
      letter-spacing: 1px;
    }
  }

  .member-stat-divider {
    width: 1px;
    height: 36px;
    background: $border;
  }
}

.member-section {
  margin-bottom: 24px;

  .member-section-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 700;
    color: $dark;
    margin-bottom: 12px;
    letter-spacing: 1px;
  }

  .member-bio-full {
    font-size: 14px;
    color: $gray;
    line-height: 1.9;
  }

  .member-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;

    .member-tag {
      padding: 5px 14px;
      font-size: 13px;
      font-weight: 500;
      color: $dark;
      background: rgba(212, 175, 55, 0.06);
      border: 1px solid rgba(212, 175, 55, 0.15);
      border-radius: 20px;
    }
  }

  .member-certs {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 10px;

    li {
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 14px;
      color: $gray;
      line-height: 1.6;
    }
  }

  .member-quote {
    position: relative;
    padding: 16px 20px;
    background: $light-gray;
    border-left: 3px solid $gold;
    border-radius: 0 8px 8px 0;
    font-size: 14px;
    font-style: italic;
    color: $gray;
    line-height: 1.8;
  }
}

.member-actions {
  display: flex;
  gap: 12px;
  margin-top: auto;
  padding-top: 20px;
  border-top: 1px solid $border;

  .btn-back {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 12px 24px;
    font-size: 14px;
    font-weight: 600;
    color: $dark;
    background: $light-gray;
    border: 1px solid $border;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    white-space: nowrap;

    &:hover {
      background: #fff;
      border-color: $gold;
      color: $gold;
    }
  }

  .btn-next {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 12px 24px;
    font-size: 14px;
    font-weight: 600;
    color: #fff;
    background: $gold;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    flex: 1;
    justify-content: center;

    &:hover:not(:disabled) {
      background: #c4a030;
      transform: translateY(-1px);
      box-shadow: 0 8px 20px rgba(212, 175, 55, 0.3);
    }

    &:disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }
  }
}

// ===== 资质 =====
.cert-section {
  padding: 80px 0;
  background: $light-gray;

  .cert-carousel {
    overflow: hidden;
    position: relative;
    margin: 0 -12px;
    padding: 8px 0;

    // 轮播轨道
    .cert-track {
      display: flex;
      gap: 24px;
      transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
      padding: 0 12px;
    }

    // 导航按钮
    .cert-nav {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.9);
      border: 1px solid $border;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      color: $dark;
      transition: all 0.3s ease;
      z-index: 10;

      &:hover {
        background: $gold;
        color: #fff;
        border-color: $gold;
        box-shadow: 0 4px 12px rgba(212, 175, 55, 0.3);
      }

      svg {
        width: 20px;
        height: 20px;
      }
    }

    .cert-nav-prev {
      left: 8px;
    }

    .cert-nav-next {
      right: 8px;
    }
  }

  .cert-item {
    cursor: pointer;
    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
    flex-shrink: 0;
    width: 240px;

    &:hover {
      transform: translateY(-6px);
      box-shadow: 0 16px 40px rgba(0,0,0,0.1);

      .cert-img-wrap {
        .cert-zoom { opacity: 1; transform: translateY(0); }
      }
    }

    .cert-img-wrap {
      position: relative;
      border-radius: 12px;
      overflow: hidden;
      background: #fff;
      border: 1px solid $border;
      aspect-ratio: 3 / 4;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 16px;

      .cert-img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        transition: transform 0.5s cubic-bezier(0.16, 1, 0.3, 1);
      }

      .cert-zoom {
        position: absolute;
        inset: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(26,26,26,0.6);
        color: #fff;
        opacity: 0;
        transform: translateY(8px);
        transition: all 0.3s ease;
      }
    }

    .cert-title {
      text-align: center;
      font-size: 14px;
      font-weight: 600;
      color: $dark;
      margin-top: 12px;
      letter-spacing: 0.5px;
    }
  }
}


// ===== Lightbox =====
.lightbox {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(0,0,0,0.9);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;

  &.open {
    opacity: 1;
    pointer-events: auto;
  }

  .lightbox-close {
    position: absolute;
    top: 24px;
    right: 24px;
    width: 44px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255,255,255,0.1);
    border: 1px solid rgba(255,255,255,0.2);
    border-radius: 50%;
    color: #fff;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(255,255,255,0.2);
      transform: rotate(90deg);
    }
  }

  .lightbox-prev,
  .lightbox-next {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 52px;
    height: 52px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255,255,255,0.1);
    border: 1px solid rgba(255,255,255,0.2);
    border-radius: 50%;
    color: #fff;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(212,175,55,0.3);
      border-color: $gold;
    }
  }

  .lightbox-prev { left: 24px; }
  .lightbox-next { right: 24px; }

  .lightbox-content {
    max-width: 85vw;
    max-height: 75vh;
    display: flex;
    align-items: center;
    justify-content: center;

    .lightbox-img {
      max-width: 100%;
      max-height: 75vh;
      object-fit: contain;
      border-radius: 8px;
      box-shadow: 0 24px 64px rgba(0,0,0,0.5);
      animation: lightboxZoomIn 0.35s cubic-bezier(0.16, 1, 0.3, 1);
    }
  }

  .lightbox-caption {
    margin-top: 20px;
    font-size: 16px;
    font-weight: 600;
    color: rgba(255,255,255,0.8);
    letter-spacing: 1px;
  }
}

@keyframes lightboxZoomIn {
  from { transform: scale(0.9); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}

// ===== CTA =====
.about-cta {
  padding: 80px 0;
  background: linear-gradient(135deg, $dark 0%, #2a2a2a 100%);
  text-align: center;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: -30%;
    right: -10%;
    width: 500px;
    height: 500px;
    background: radial-gradient(circle, rgba(212,175,55,0.08) 0%, transparent 70%);
    border-radius: 50%;
  }

  .cta-content {
    position: relative;
    z-index: 2;

    .section-tag { margin-bottom: 16px; }

    h2 {
      font-size: 36px;
      font-weight: 800;
      color: #fff;
      margin-bottom: 12px;
    }

    p {
      font-size: 16px;
      color: rgba(255,255,255,0.5);
      margin-bottom: 36px;
    }
  }

  .cta-actions {
    display: flex;
    gap: 16px;
    justify-content: center;
  }
}

.btn-gold {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 14px 36px;
  font-size: 15px;
  font-weight: 600;
  color: $dark;
  background: $gold;
  border: none;
  border-radius: 8px;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.35s ease;

  &:hover {
    background: #c4a030;
    transform: translateY(-2px);
    box-shadow: 0 12px 32px rgba(212,175,55,0.3);
  }
}

.btn-outline-dark {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 14px 36px;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  background: transparent;
  border: 1px solid rgba(255,255,255,0.3);
  border-radius: 8px;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.35s ease;

  &:hover {
    background: rgba(255,255,255,0.08);
    border-color: rgba(255,255,255,0.7);
    transform: translateY(-2px);
  }
}

// ===== 响应式 =====
@media (max-width: 1024px) {
  .about-hero { min-height: 400px; }
  .about-hero-content { padding: 40px 0; }
  .about-hero-content .about-hero-title { font-size: 40px; }
  .company-intro .intro-grid { grid-template-columns: 1fr; }
  .advantages-grid { grid-template-columns: repeat(2, 1fr); }
  .team-grid { grid-template-columns: repeat(2, 1fr); }
  .cert-grid { grid-template-columns: repeat(2, 1fr); }
  .timeline-item.is-left .timeline-content,
  .timeline-item.is-right .timeline-content {
    text-align: left;
    padding: 16px 20px;
    margin: 0;
  }
  .timeline-item.is-left .timeline-dot,
  .timeline-item.is-right .timeline-dot {
    left: 20px;
    transform: translateX(0);
  }
  .timeline::before { left: 20px; }
  .timeline-item { justify-content: flex-start; }
  .timeline-content {
    width: calc(100% - 48px) !important;
    margin-left: 48px !important;
  }
}

@media (max-width: 768px) {
  .about-hero { min-height: 340px; margin-top: 72px; }
  .about-hero-content { padding: 40px 0; }
  .about-hero-content .about-hero-title { font-size: 32px; }
  .hero-stats-row { flex-wrap: wrap; gap: 16px; }
  .hero-stat-divider { display: none; }
  .advantages-grid { grid-template-columns: 1fr; }
  .team-grid { grid-template-columns: repeat(2, 1fr); }
  .cert-grid { grid-template-columns: repeat(2, 1fr); }
  .section-title { font-size: 28px; }
  .cta-actions { flex-direction: column; align-items: center; }
  .btn-gold, .btn-outline-dark {
    width: auto !important;
    justify-content: center;
    padding: 14px 36px !important;
    font-size: 15px !important;
  }
  .intro-tags { grid-template-columns: 1fr; }
  .member-container { grid-template-columns: 1fr; max-height: 92vh; width: 95%; }
  .member-photo-wrap { padding: 32px 24px; min-height: 200px; }
  .member-details { padding: 24px 20px; }
  .member-stats-row { gap: 12px; padding: 16px; }
  .member-stat .stat-num { font-size: 22px; }
  .member-prev, .member-next { width: 40px; height: 40px; }
  .member-prev { left: 12px; }
  .member-next { right: 12px; }
  .member-close { top: 12px; right: 12px; width: 36px; height: 36px; }
  .member-actions { flex-direction: column; }
  .member-actions .btn-back, .member-actions .btn-next { width: 100%; justify-content: center; }
}

</style>
